import React from 'react';
import { HeroBanner } from '../components/home/HeroBanner';
import { ShopByNeed } from '../components/home/ShopByNeed';
import { BestSellersCarousel } from '../components/home/BestSellersCarousel';
import { NutritionHighlight } from '../components/home/NutritionHighlight';
import { SupplementsSection } from '../components/home/SupplementsSection';
import { BundleDealsSection } from '../components/home/BundleDealsSection';
import { FaqSection } from '../components/home/FaqSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { NewsletterSection } from '../components/home/NewsletterSection';
import { Product } from '../types/store';

interface HomePageProps {
  onSelectProduct: (product: Product) => void;
  onNavigate: (pageId: string) => void;
}

export const HomePage: React.FC<HomePageProps> = ({
  onSelectProduct,
  onNavigate,
}) => {
  return (
    <div id="home-page-container" className="w-full">
      {/* 1. Hero Banner */}
      <HeroBanner
        onShopAll={() => onNavigate('shop-all')}
        onExploreBundles={() => onNavigate('bundles')}
        onSelectProduct={onSelectProduct}
      />

      {/* 2. Direct Products Showcase right after Hero */}
      <BestSellersCarousel
        onSelectProduct={onSelectProduct}
        onViewAll={() => onNavigate('shop-all')}
      />

      {/* 3. Promotional Nutrition Spotlight */}
      <NutritionHighlight onShopNow={() => onNavigate('shop-all')} />

      {/* 4. Supplements Section */}
      <SupplementsSection
        onSelectProduct={onSelectProduct}
        onViewAll={() => onNavigate('supplements')}
      />

      {/* 5. Buy More Save More / Bundles */}
      <BundleDealsSection onSelectProduct={onSelectProduct} />

      {/* 6. Shop by Need / Specialized Care (Placed towards end) */}
      <ShopByNeed
        onSelectCategory={(category) => {
          if (category === 'supplements') onNavigate('supplements');
          else if (category === 'weight-gain') onNavigate('shop-all');
          else onNavigate('shop-all');
        }}
      />

      {/* 7. Customer Reviews */}
      <ReviewsSection />

      {/* 8. FAQ */}
      <FaqSection />

      {/* 9. Newsletter */}
      <NewsletterSection />
    </div>
  );
};
